export enum ExploreActivitiesOptions {
  ContinueWithExistingClass = 'ContinueWithExistingClass',
  CreateNewClass = 'CreateNewClass'
}
